import { render } from "./InvoiceReport.vue?vue&type=template&id=35738cf4"
import script from "./InvoiceReport.vue?vue&type=script&lang=js"
export * from "./InvoiceReport.vue?vue&type=script&lang=js"

import "./InvoiceReport.vue?vue&type=style&index=0&id=35738cf4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__